import styled from 'styled-components'
import { lightgrey } from '../../../../../../../../../Styles/colors'
import {
  center,
  hFlex,
  vFlex,
} from '../../../../../../../../../Styles/style-helpers'
import { H4 } from '../../../../../../../../../Styles/typography'

export const BatchTimingsEl = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  ${vFlex};
  justify-content: flex-start;
  overflow: auto;
  padding: 1.5em 1.5em 0;

  .header {
    ${hFlex};
    width: 100%;
    justify-content: space-between;
    margin-bottom: 1em;

    ${H4} {
      width: 100%;
    }

    .header-btns {
      width: 100%;
      ${hFlex};
      justify-content: flex-end;

      button {
        margin-right: 0.5em;
      }
    }
  }

  .batchTimings-content {
    ${vFlex};
    width: 100%;
    height: 100%;
    flex: 1;
    margin-top: 1em;
    overflow: auto;
    justify-content: flex-start;
    padding-right: 1em;

    .week {
      width: 100%;
      margin: 0 0 1em;

      .classes {
        display: grid;
        grid-template-columns: auto auto;

        .classCard {
          margin: 0.5em;
          border: 0;

          .row {
            font-size: 0.9em;

            .status {
              position: absolute;
              top: 0.6em;
              right: 0.6em;
              pointer-events: auto;
            }

            .recordingBtn {
              position: absolute;
              bottom: 0.6em;
              right: 0;
              transform: scale(0.8);
            }
          }
        }
      }
    }
  }
`

export const TimingsEl = styled.div`
  padding: 1em;
  border: 1px solid ${lightgrey};
  border-radius: 10px;
  margin: 1em;
`

export const RescheduleModalEl = styled.div`
  ${center}
  ${vFlex}
  min-width: 30%;
  max-width: 75%;
  max-height: 80vh;
  padding: 2em 1em;
  background: white;
  border-radius: 1em;
  box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.25);
  justify-content: flex-start;
  overflow: auto;

  ${H4} {
    width: 100%;
    text-align: center;
  }

  form {
    width: 100%;
    padding: 0.5em;
  }
`

export const NotifyModalEl = styled.div`
  ${center}
  ${vFlex}
  min-width: 30%;
  max-width: 75%;
  max-height: 80vh;
  padding: 2em 1em;
  background: white;
  border-radius: 1em;
  box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.25);
  justify-content: flex-start;
  overflow: auto;

  ${H4} {
    width: 100%;
    text-align: center;
  }

  form {
    width: 100%;
    padding: 0.5em;
    ${vFlex};

    > div {
      width: 100%;
    }

    button {
      margin-top: 1em;
    }
  }
`
